export const environment = {
  production: false,
  awsCognitoIdentityPool: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL || '',
  awsUserPoolsId: process.env.REACT_APP_AWS_USER_POOLS_ID || '',
  awsUserPoolClientId: process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID || '',
  awsOauthDomain: 'crm-gorilamx.auth.us-east-1.amazoncognito.com',
  awsOauthScope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
  awsOauthResponseType: 'code' as 'code' | 'token',
  awsOauthRedirectSignIn: process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGN_IN?.split(',') || ['http://localhost:3000/'],
  awsOauthredirectSignOut: process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGN_OUT?.split(',') || ['http://localhost:3000/'],
  awsAPIEndpointName: 'apiGorila',
  awsAPIEndpointUrl: process.env.REACT_APP_API_ENDPOINT_URL || '',
  awsMediaS3Bucket: process.env.REACT_APP_AWS_BUCKET_NAME || '',
  awsMediaS3BucketRegion: 'us-east-1',
  googleMapsAPIKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  mapboxAPIKey: process.env.REACT_APP_MAPBOX_API_KEY || '',
  datadogClientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  datadogSite: process.env.REACT_APP_DATADOG_SITE,
  datadogService: process.env.REACT_APP_DATADOG_SERVICE,
  datadogEnv: process.env.REACT_APP_DATADOG_ENV,
  // RUM
  rumRegion: 'us-east-1',
  rumIdentityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID,
  rumApplicationId: process.env.REACT_APP_RUM_APPLICATION_ID,
  rumVersion: process.env.REACT_APP_RUM_VERSION,
};
